import Repository from "./Repository";

const mockExams = "/mock-exams";

export default {
  create: (payload) => Repository.post(`${mockExams}/`, payload),
  teacherList: () => Repository.get(`${mockExams}/`),
  getMockExamForTeacher: (id) => Repository.get(`${mockExams}/${id}/`),
};
